export default "__VITE_ASSET__Zqv6RAwA__"